import * as React from 'react'

const FavoriteTrip = (props: any) => {
  return (
    <svg {...props} width='20' height='26' viewBox='0 0 20 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M9 24C5.967 20.3455 0 12.6997 0 8.1289C0 3.64639 4.03714 0 9 0C13.9629 0 18 3.64639 18 8.1289C18 12.6997 12.033 20.3466 9 24'
        transform='translate(1 1)'
        stroke='#838383'
        strokeWidth='1.5'
      />
      <path
        d='M4.5 0L5.51031 3.10942L8.77975 3.10942L6.13472 5.03115L7.14503 8.14058L4.5 6.21885L1.85497 8.14058L2.86528 5.03115L0.220246 3.10942L3.48969 3.10942L4.5 0Z'
        transform='translate(5.5 5)'
        fill='#838383'
      />
    </svg>
  )
}

export default FavoriteTrip



// WEBPACK FOOTER //
// ./src/components/icons/ui/FavoriteTrip.tsx